(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  let dispose = () => {};
  function initialise() {
    dispose();
    if (preference.matches) return;
    const controller = new AbortController();
    const animations = new Set();
    const seen = new WeakSet();
    const revealNodes = [...document.querySelectorAll('.cc-hero-copy > *, .cc-category-section > h2, .cc-category-section > p, .cc-category, .cc-feature > div:first-child, .cc-feature .cc-product, .cc-editorial > *, [data-cc-reveal], [data-cc-chapter]')];
    const reveal = node => {
      if (seen.has(node) || typeof node.animate !== 'function') return;
      seen.add(node);
      const sibling = node.parentElement?.classList.contains('cc-category-grid') ? [...node.parentElement.children].indexOf(node) % 2 : 0;
      const animation = node.animate([{ opacity:0, transform:'translate3d(0,22px,0)' }, { opacity:1, transform:'translate3d(0,0,0)' }], { duration:650, delay:sibling * 65, easing:'cubic-bezier(.2,.65,.25,1)' });
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { reveal(entry.target); observer.unobserve(entry.target); } });
    }, { threshold:.08, rootMargin:'0px 0px -25px 0px' }) : null;
    revealNodes.forEach(node => observer?.observe(node));
    const hero = document.querySelector('.cc-hero-media');
    const stories = [...document.querySelectorAll('[data-cc-story]')].map(node => ({node, chapters:[...node.querySelectorAll('[data-cc-chapter]')]}));
    let frame = 0;
    const clamp = n => Math.min(1,Math.max(0,n));
    function update() {
      frame = 0;
      const viewport = window.innerHeight;
      if (hero) {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < viewport) {
          const progress = clamp((viewport - rect.top)/(viewport + rect.height));
          hero.style.setProperty('--cc-hero-y',(progress * -20 + 10).toFixed(1)+'px');
          hero.style.setProperty('--cc-hero-scale',(1 + progress*.025).toFixed(3));
        }
      }
      stories.forEach(({node,chapters}) => {
        const rect = node.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= viewport) return;
        const progress = clamp((viewport*.5 - rect.top)/Math.max(1,rect.height - viewport*.35));
        node.style.setProperty('--cc-story-progress',progress.toFixed(3));
        node.style.setProperty('--cc-story-scale',(.94+progress*.1).toFixed(3));
        node.style.setProperty('--cc-story-y',(8-progress*16).toFixed(1)+'px');
        node.style.setProperty('--cc-halo-x',(progress*12-6).toFixed(1)+'%');
        let closest = null, distance = Infinity;
        chapters.forEach(chapter => {
          const r = chapter.getBoundingClientRect(), delta = Math.abs(r.top+r.height*.5-viewport*.65);
          if (delta < distance) { distance=delta;closest=chapter; }
        });
        chapters.forEach(chapter => chapter.classList.toggle('is-active',chapter===closest));
      });
    }
    const schedule = () => { if (!frame) frame=requestAnimationFrame(update); };
    window.addEventListener('scroll',schedule,{passive:true,signal:controller.signal});
    window.addEventListener('resize',schedule,{passive:true,signal:controller.signal});
    document.documentElement.classList.add('cc-motion-on');
    schedule();
    dispose = () => {
      controller.abort();observer?.disconnect();if(frame)cancelAnimationFrame(frame);
      animations.forEach(a=>a.cancel());
      document.documentElement.classList.remove('cc-motion-on');
      [hero,...stories.map(s=>s.node)].filter(Boolean).forEach(node => ['--cc-hero-y','--cc-hero-scale','--cc-story-progress','--cc-story-scale','--cc-story-y','--cc-halo-x'].forEach(key=>node.style.removeProperty(key)));
    };
  }
  initialise();
  preference.addEventListener('change',initialise);
  document.addEventListener('shopify:section:load',initialise);
})();
